import React, { useRef, useState } from "react";
import Modal from "@/components/Modal";
import { getAndroidAppList } from "@/apis/apiCollection";
import DataTable from "@/components/DataTable";
import { makeStyles } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";

const useStyles = makeStyles(theme => ({
  systemBtnWrapper: {
    display: "flex",
    marginBottom: 32
  },
  systemBtn: {
    border: "1px solid #DDD",
    color: "#DDD",
    borderRadius: "6px",
    width: "120px",
    height: "40px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  },
  systemBtnChosen: {
    border: "1px solid #00AFC6",
    color: "#00AFC6",
    borderRadius: "6px",
    width: "120px",
    height: "40px",
    fontSize: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer"
  },
  root: {
    borderRadius: 4,
    overflow: "hidden",
    border: "1px solid #E9E8ED",
    marginTop: theme.spacing(2)
  }
}));

const AppModal = ({ open, onClose, onChange, index }) => {
  const [system, setSystem] = useState("android");
  const classes = useStyles();
  const { t } = useTranslation();
  const ref = useRef();

  const columns =
    system === "android"
      ? [
          {
            data: "id",
            type: "checkbox"
          },
          {
            data: "package_name",
            title: t({ defaultMessage: "应用程序名称" }),
            searchable: false,
            orderable: false
          },
          {
            data: "package_id",
            title: t({ defaultMessage: "程序包ID" }),
            searchable: false,
            orderable: false
          }
        ]
      : [
          {
            data: "id",
            type: "checkbox"
          },
          {
            data: "package_name",
            title: t({ defaultMessage: "应用程序名称" }),
            searchable: false,
            orderable: false
          },
          {
            data: "package_id",
            title: t({ defaultMessage: "进程名" }),
            searchable: false,
            orderable: false,
            render: v => v || ""
          }
        ];
  const ajax = (data, callback) => {
    return getAndroidAppList({
      ...data,
      target: system,
      parent_id: ""
      // order: [{ column: 9, dir: "desc" }]
    }).then(res => {
      callback({
        data: res.data,
        draw: data.draw,
        recordsFiltered: res.recordsTotal,
        recordsTotal: res.recordsTotal
      });
    });
  };

  const onConfirm = () => {
    const selected = ref.current.getSelectedRows();
    if (selected.length) {
      if (system === "android") {
        onChange(selected[0].package_id, "", "", "app", index, {
          app: selected[0].package_id
        });
      }
      if (system === "windows") {
        onChange(selected[0].package_id, "", "", "app", index, {
          app: selected[0].package_id
        });
      }
      if (system === "linux") {
      }
      onClose();
    }
  };

  if (!open) return null;
  return (
    <Modal open onClose={onClose} onConfirm={onConfirm} width={794}>
      <div className={classes.systemBtnWrapper}>
        <div
          className={
            system === "android" ? classes.systemBtnChosen : classes.systemBtn
          }
          onClick={() => setSystem("android")}
        >
          Android
        </div>
        <div
          className={
            system === "windows" ? classes.systemBtnChosen : classes.systemBtn
          }
          style={{ marginLeft: 24 }}
          onClick={() => setSystem("windows")}
        >
          Windows
        </div>
      </div>
      <DataTable
        ref={ref}
        ordering
        columns={columns}
        ajax={ajax}
        autoLoad
        scrollable
        showCheckAll={false}
        singleCheck
        key={system}
      />
    </Modal>
  );
};

export default AppModal;
